import { useState } from "react";
import { toast } from "sonner";
import { Plus } from "@phosphor-icons/react";
import api, { formatApiError } from "../../lib/api";
import TeamAvailabilitySidebar from "../../components/TeamAvailabilitySidebar";

export default function Leaves({ leaves, employees, onChange }) {
  const [form, setForm] = useState({
    employee_id: "", type: "annual",
    start_date: "", end_date: "", reason: "", half_day: "",
  });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...form, half_day: form.half_day || null };
      if (payload.half_day && payload.start_date !== payload.end_date) {
        toast.error("Half-day leaves must be a single date");
        return;
      }
      await api.post("/hr/leaves", payload);
      toast.success("Leave requested");
      setForm({ employee_id: "", type: "annual", start_date: "", end_date: "", reason: "", half_day: "" });
      onChange();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  const setStatus = async (id, s) => {
    await api.patch(`/hr/leaves/${id}?status=${s}`);
    onChange();
  };

  return (
    <div>
      <form onSubmit={submit} className="grid grid-cols-2 md:grid-cols-[1fr_120px_140px_140px_100px_1fr_auto] gap-px bg-zinc-200 border-b border-zinc-950" data-testid="leave-form">
        <select value={form.employee_id} onChange={(e) => set("employee_id", e.target.value)} required data-testid="leave-emp-select" className="bg-white px-3 py-3 text-sm outline-none">
          <option value="">— employee —</option>
          {employees.map((e) => <option key={e.id} value={e.id}>{`${e.employee_no} · ${e.name}`}</option>)}
        </select>
        <select value={form.type} onChange={(e) => set("type", e.target.value)} data-testid="leave-type-select" className="bg-white px-3 py-3 text-sm outline-none">
          {["annual", "sick", "unpaid", "maternity"].map((t) => <option key={t}>{t}</option>)}
        </select>
        <input type="date" value={form.start_date} onChange={(e) => set("start_date", e.target.value)} required data-testid="leave-start-input" className="bg-white px-3 py-3 text-sm outline-none" />
        <input type="date" value={form.end_date} onChange={(e) => set("end_date", e.target.value)} required data-testid="leave-end-input" className="bg-white px-3 py-3 text-sm outline-none" />
        <select value={form.half_day} onChange={(e) => set("half_day", e.target.value)} data-testid="leave-halfday-select" className="bg-white px-3 py-3 text-sm outline-none">
          <option value="">Full day</option>
          <option value="am">AM ½</option>
          <option value="pm">PM ½</option>
        </select>
        <input value={form.reason} onChange={(e) => set("reason", e.target.value)} placeholder="Reason" className="bg-white px-3 py-3 text-sm outline-none" />
        <button type="submit" className="bg-zinc-950 text-white text-xs font-semibold px-5 hover:bg-[#FF3E00] flex items-center justify-center gap-1" data-testid="leave-submit-btn">
          <Plus size={14} /> REQUEST
        </button>
      </form>
      <div className="px-4 py-3 bg-white border-b border-zinc-100">
        <TeamAvailabilitySidebar start={form.start_date} end={form.end_date} employeeId={form.employee_id || null} />
      </div>
      <table className="w-full text-sm">
        <thead className="bg-zinc-50 border-b border-zinc-950">
          <tr className="text-xs tracking-wider uppercase">
            <th className="text-left px-4 py-2.5">Employee</th>
            <th className="text-left px-4 py-2.5">Type</th>
            <th className="text-left px-4 py-2.5">From</th>
            <th className="text-left px-4 py-2.5">To</th>
            <th className="text-left px-4 py-2.5">Status</th>
            <th className="w-44" />
          </tr>
        </thead>
        <tbody data-testid="leaves-tbody">
          {leaves.map((l) => {
            const emp = employees.find((e) => e.id === l.employee_id);
            return (
              <tr key={l.id} className="border-b border-zinc-100">
                <td className="px-4 py-2.5">{emp ? `${emp.employee_no} · ${emp.name}` : l.employee_id}</td>
                <td className="px-4 py-2.5 capitalize text-zinc-600">{l.type}</td>
                <td className="px-4 py-2.5 tnum text-xs">{l.start_date}</td>
                <td className="px-4 py-2.5 tnum text-xs">{l.end_date}</td>
                <td className="px-4 py-2.5"><span className={`text-[10px] px-1.5 py-0.5 ${l.status === "approved" ? "bg-emerald-50 text-emerald-700" : l.status === "rejected" ? "bg-red-50 text-[#D0021B]" : "bg-amber-50 text-amber-700"}`}>{l.status?.toUpperCase()}</span></td>
                <td className="px-4 py-2.5">
                  {l.status === "pending" && (
                    <div className="flex gap-2">
                      <button onClick={() => setStatus(l.id, "approved")} className="text-[10px] font-mono text-emerald-700 hover:underline" data-testid={`leave-approve-${l.id}`}>APPROVE</button>
                      <button onClick={() => setStatus(l.id, "rejected")} className="text-[10px] font-mono text-[#D0021B] hover:underline">REJECT</button>
                    </div>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
